import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Jobs = () => {
  const { t } = useTranslation();

  return (
    <div className="container">
      <div>
        <h2 className="h1">{t('jobs.heading')}</h2>
        <br />
        <p>{t('jobs.intro1')}</p>
        <p>{t('jobs.intro2')}</p>
      </div>

      <div>
        <h3>{t('jobs.offersTitle')}</h3>
        <ul>
          {t('jobs.offersItems', { returnObjects: true }).map((item, i) => (
            <li key={i}>- {item}</li>
          ))}
        </ul>

        <br />

        <h3>{t('jobs.expectsTitle')}</h3>
        <ul>
          {t('jobs.expectsItems', { returnObjects: true }).map((item, i) => (
            <li key={i}>- {item}</li>
          ))}
        </ul>

        <br />

        {/* Sits between the experience requirements and the openings: readers
            who have just seen "1-2 years required" are the ones the courses
            are for. <Link> keeps the active language prefix (/en, /de) and
            renders a crawlable <a href>. */}
        <div className="vb-jobs-cta">
          <p>{t('jobs.ctaText')}</p>
          <Link to="/educations" className="vb-jobs-cta__btn">
            {t('jobs.ctaButton')}
          </Link>
        </div>

        <h3>{t('jobs.positionsTitle')}</h3>

        <br />

        <h4>{t('jobs.hairdresser.title')}</h4>
        <p>{t('jobs.hairdresser.desc')}</p>
        <p>{t('jobs.hairdresser.exp')}</p>
        <p>{t('jobs.hairdresser.apply')}</p>

        <h4>{t('jobs.lashArtist.title')}</h4>
        <p>{t('jobs.lashArtist.desc1')}</p>
        <p>{t('jobs.lashArtist.desc2')}</p>
        <p>{t('jobs.lashArtist.exp')}</p>
        <p>{t('jobs.lashArtist.apply')}</p>

        <h4>{t('jobs.nailArtist.title')}</h4>
        <p>{t('jobs.nailArtist.desc')}</p>
        <p>{t('jobs.nailArtist.exp')}</p>
        <p>{t('jobs.nailArtist.apply')}</p>

        <h4>{t('jobs.makeup.title')}</h4>
        <p>{t('jobs.makeup.desc')}</p>
        <p>{t('jobs.makeup.exp')}</p>
        <p>{t('jobs.makeup.apply')}</p>

        <br />
      </div>

      {/* Visitors landing here from "posao šminkera" searches are usually still
          training - point them at the salon's own makeup courses. */}
      <style>{`
        .vb-jobs-cta {
          background: #FAF7F2;
          border: 1px solid rgba(144, 81, 15, 0.18);
          border-radius: 20px;
          padding: 40px 36px;
          margin: 34px 0 44px;
          text-align: center;
        }
        .vb-jobs-cta p {
          font-family: 'Inter', sans-serif;
          font-size: 17px;
          line-height: 1.7;
          color: #5a4a3a;
          max-width: 640px;
          margin: 0 auto 28px;
        }
        .vb-jobs-cta__btn {
          display: inline-block;
          font-family: 'Inter', sans-serif;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          background: #90510F;
          color: #fff;
          padding: 16px 38px;
          border-radius: 9999px;
          text-decoration: none;
          box-shadow: 0 8px 24px rgba(144, 81, 15, 0.28);
          transition: background 0.3s ease, transform 0.2s ease;
        }
        .vb-jobs-cta__btn:hover,
        .vb-jobs-cta__btn:focus {
          background: #6b3b08;
          color: #fff;
          transform: translateY(-2px);
        }
        @media (max-width: 767px) {
          .vb-jobs-cta { padding: 30px 20px; margin: 26px 0 34px; border-radius: 16px; }
          .vb-jobs-cta p { font-size: 16px; margin-bottom: 24px; }
          .vb-jobs-cta__btn { padding: 15px 28px; font-size: 11px; }
        }
      `}</style>
    </div>
  );
};

export default Jobs;
